<template>
    <div class="list-group list-group-flush">
        <template v-for="session in sessions">
            <template v-if="canRegister(session)">
                <router-link :to="sessionRoute(session)" custom v-slot="{ href }">
                    <a class="list-group-item list-group-item-action font-weight-normal py-3 px-print-0" :href="href">
                        <div class="row mb-n1">
                            <div class="col-md mb-1">
                                <div class="font-weight-bold">
                                    {{ session.title }}
                                </div>
                                <template v-if="session.short_description">
                                    <div class="small mt-2" v-html="session.short_description">
                                    </div>
                                </template>
                            </div>
                            <template v-if="session.registration_deadline">
                                <div class="col-auto align-self-center mb-1">
                                    <div class="small text-body text-md-right" style="line-height: 1.5">
                                        <template v-if="session.gauge">
                                            <div class="mb-1">
                                                <SessionGaugeLabel :session="session" />
                                            </div>
                                        </template>
                                        <template v-if="session.registration_deadline">
                                            <div>
                                                <SessionDeadlineLabel :course="course" :session="session" block />
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </a>
                </router-link>
            </template>
            <template v-else>
                <div class="list-group-item font-weight-normal py-3 px-print-0" :class="{ 'text-muted': !isAvailable(session) }">
                    {{ session.title }}
                    <SessionStateLabel class="ml-1" :session="session" />
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    import SessionStateLabel from "./SessionStateLabel";
    import SessionDeadlineLabel from "./SessionDeadlineLabel";
    import SessionGaugeLabel from "./SessionGaugeLabel";

    export default {
        components: {
            SessionGaugeLabel,
            SessionStateLabel,
            SessionDeadlineLabel,
        },
        props: {
            course: Object,
            sessions: Array,
            sessionRoute: Function,
        },
        methods: {
            canRegister(session) {
                return session.state === 'OK';
            },
            isAvailable(session) {
                return session.state === 'OK' || session.state === 'FREE';
            },
        },
    }
</script>
